import api from "./axios";


/*
|--------------------------------------------------------------------------
| LIST
|--------------------------------------------------------------------------
*/

export const getAppraisals = async (
    page = 1,
    limit = 10,
    filters = {}
) => {

    const response = await api.get(
        "/appraisals",
        {
            params: {
                page,
                limit,
                ...filters,
            },
        }
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| SINGLE
|--------------------------------------------------------------------------
*/

export const getAppraisal = async (
    id
) => {

    const response = await api.get(
        `/appraisals/${id}`
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| CREATE
|--------------------------------------------------------------------------
*/

export const createAppraisal = async (
    data
) => {

    const response = await api.post(
        "/appraisals",
        data
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| UPDATE
|--------------------------------------------------------------------------
*/

export const updateAppraisal = async (
    id,
    data
) => {

    const response = await api.patch(
        `/appraisals/${id}`,
        data
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| DELETE / CANCEL
|--------------------------------------------------------------------------
*/

export const deleteAppraisal = async (
    id
) => {

    const response = await api.delete(
        `/appraisals/${id}`
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| SUBMIT
|--------------------------------------------------------------------------
*/

export const submitAppraisal = async (
    id
) => {

    const response = await api.post(
        `/appraisals/${id}/submit`
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| APPROVE
|--------------------------------------------------------------------------
*/

export const approveAppraisal = async (
    id,
    data = {}
) => {

    const response = await api.post(
        `/appraisals/${id}/approve`,
        data
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| REJECT
|--------------------------------------------------------------------------
*/

export const rejectAppraisal = async (
    id,
    data
) => {

    const response = await api.post(
        `/appraisals/${id}/reject`,
        data
    );

    return response.data;
};